import React, { useEffect, useMemo, useState } from 'react'
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import deleteDocument from '../../../api/deleteDocument';
import getDocumentsInProgress from '../../../api/getDocumentsInProgress';
import DocumentModal from './DocumentModal';
import MinimizableContainer from './MinimizableContainer';
import ResearchKeyDropdown from './ResearchKeyDropdown';
import validateFormDocument from '../../../api/validateFormDocument';
import BootstrapTable from 'react-bootstrap-table-next';
import Preferences from './Preferences';
import Loader from '../../utilities/loader';
import { Table, Tooltip } from 'antd';
import { showToastAction } from '../../../redux/toastSlice';
import filterInProgressDocuments from '../../../api/filterInProgressDocuments';
import { setPreferences } from '../../../redux/preferencesSlice';
import { BiDownload } from 'react-icons/bi';

const DocumentsInProgress = () => {
    const dispatch = useDispatch()
    const selectedProject = useSelector(state => state.selectedProject);
    const { form_name } = useParams();
    const { isLoading, data: documents, refetch } = useQuery("getDocumentsInProgress" + selectedProject.name + form_name, () => getDocumentsInProgress(selectedProject.name, form_name))
    const [minimized, setMinimized] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [isReadMore, setIsReadMore] = useState(false);
    const [showPreferences, setShowPreferences] = useState(false);

    const history = useHistory()
    const [currentDataSource, setCurrentDataSource] = useState([]);
    const preferences = useSelector(state => state.preferences);
    const preferencesArray = Object.entries(preferences)
    const filteredPreferences = preferencesArray.filter((el) => el[1] === true);
    const [appliedFilters, setAppliedFilters] = useState({});
    const [antTableCols, setAntTableCols] = useState([])
    const [uniqueFilters, setUniqueFilters] = useState([])

    // Function to format multiple values with commas
    const formatCellValue = (value) => {
        if (!value) return '';
        if (Array.isArray(value)) {
            return value.join(', ');
        }
        if (typeof value === 'string' && value.includes(',')) {
            return value.split(',').map(item => item.trim()).join(', ');
        }
        return value;
    }

    useEffect(() => {
        let DataSource = currentDataSource.length > 0 ? currentDataSource : documents?.data?.data ?? []
        if (DataSource.length > 0) {
            let filters = Object.keys(DataSource[0]).map((item) =>
                ({ [item]: [...new Set(DataSource.map(mainItem => mainItem[item]))] })
            )
            setUniqueFilters(filters)
        }
    }, [documents?.data?.data, currentDataSource, filteredPreferences.toString()])

    useEffect(() => {
        if (documents?.data?.data.length > 0 && uniqueFilters.length > 0) {
            let antTableColsStruct = [
                ...filteredPreferences.map((([key]) => {
                    return {
                        title: key,
                        dataIndex: key,
                        key: key,
                        width: `${100 / filteredPreferences.length}%`,
                        render: (_, record) => {
                            const formattedValue = formatCellValue(record[key]);
                            return (
                                <Tooltip title={formattedValue}>
                                    <div className='long-text-wrapper-div'>
                                        {formattedValue}
                                    </div>
                                </Tooltip>
                            )
                        },
                        sorter: (a, b) => a[key]?.localeCompare(b[key]),
                        filters: uniqueFilters?.some((item) => Object.keys(item)[0] === key) ?
                            Object.values(uniqueFilters?.find((item) => Object.keys(item)[0] === key)).flat()
                                .map((item) => ({ "text": item, "value": item })) : [],
                        onFilter: (value, record) => record[key]?.indexOf(value) === 0,
                    }
                })),
                {
                    title: 'Action',
                    key: 'action',
                    width: `${100 / filteredPreferences.length}%`,
                    render: (_, val) => (
                        <div className="d-flex"
                            style={{
                                justifyContent: "flex-end",
                                maxWidth: '230px',
                                minWidth: '230px',
                                marginLeft: 'auto'
                            }}
                        >
                            <button onClick={() => handleEditObject(val)} className="edit-btn" title="edit"><i className="ti-pencil-alt"></i></button>
                            <button className='edit-btn download-btn' title='validate' onClick={() => handleValidateFormDocument(form_name, val._id)}><i className="ti-check-box"></i></button>
                            <button className="remove-btn" title="delete" onClick={() => handleDeleteDocument(val._id)}><i className="ti-trash"></i></button>
                        </div>
                    ),
                },
            ]

            setAntTableCols(antTableColsStruct)
        }
    }, [documents?.data?.data, uniqueFilters, filteredPreferences.toString()])

    if (isLoading) return <><Loader /></>

    const documentsColumns = [
        ...filteredPreferences.map((([key]) => {
            return {
                dataField: key,
                text: key,
                formatter: (data) => formatterColumn(data)
            }
        })),
        {
            dataField: 'd',
            text: 'Actions',
            headerAlign: 'center',
            formatter: (data, val, rowIndex) => {
                return <div
                    className="d-flex"
                    style={{
                        justifyContent: "flex-end",
                        maxWidth: '160',
                        minWidth: 'fit-content',
                        marginLeft: 'auto'
                    }}>
                    <button onClick={() => handleEditObject(val)} className="edit-btn" title="edit"><i className="ti-pencil-alt"></i></button>
                    <button className="validate-btn" title="validate" onClick={() => handleValidateFormDocument(form_name, val._id)}><i className="ti-check-box"></i></button>
                    <button className="remove-btn" title="delete" onClick={() => handleDeleteDocument(val._id)}><i className="ti-trash"></i></button>
                </div>
            },
            style: (cell, row, rowIndex, colIndex) => {
                return {
                    width: 50,
                }
            }
        },
    ];

    const formatterColumn = (data) => {
        return data ? <SmartText text={data} /> : '-'
    }

    const handleShow = (document) => {
        setSelectedDocument({ ...document });
        setShowModal(true);
    }

    const handleEditObject = (document) => {
        // Rediriger vers la page d'édition d'objet avec le paramètre from=drafts
        history.push(`/form/${form_name}/edit-object/${document._id}?from=drafts`);
    }

    const handleClose = () => {
        setShowModal(false)
        setSelectedDocument(null)
        refetch();
    };

    const handleDeleteDocument = async (id) => {
        try {
            let res = await deleteDocument(selectedProject.name, form_name, id)
            dispatch(showToastAction({ message: res?.data?.data ?? "Success", showToast: true, severity: "success" }))
            refetch();
        }
        catch (err) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }

    const handleValidateFormDocument = async (form, documentID) => {
        try {
            let validateRes = await validateFormDocument(selectedProject.name, form, documentID)

            if (validateRes.status === 200) {
                refetch();
                dispatch(showToastAction({ message: validateRes?.data?.data ?? "Validate Success", showToast: true, severity: "success" }))
            }
            // history.go(0);
        }
        catch (err) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }

    const toggleReadMore = (value) => {
        setIsReadMore(!isReadMore);
    };

    const SmartText = ({ text, length = 20 }) => {
        const [showLess, setShowLess] = React.useState(true);

        if (text.length < length) {
            return <div>{text}</div>;
        }

        return (
            <div>
                {showLess ? text.slice(0, length) : text}
                {showLess ? <a className="read-or-hide" onMouseOver={() => setShowLess(!showLess)}
                >....</a> : <a className="read-or-hide" onMouseOver={() => setShowLess(true)}
                >...less</a>}
            </div>
        );
    };

    const toggleModel = () => {
        setShowPreferences(!showPreferences)
    }

    const onChange = (pagination, filters, sorter, extra) => {
        setCurrentDataSource(extra?.currentDataSource || [])
        setAppliedFilters(filters)
    };

    const HandleDownload = () => {
        const downloadFilteredData = () => {
            let data = {
                "query": appliedFilters
            }
            filterInProgressDocuments(selectedProject.name, form_name, data).then((res) => {
                if (res?.status === 200) {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `document.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                }
            })
        }

        return (
            <Button size="sm" onClick={() => downloadFilteredData()}>
                <i className="ti-download"></i>
            </Button>
        )
    }

    return (
        <MinimizableContainer
            // OptionsButton={() => ResearchKeyDropdown({ "documentsStatus": "inProgress" })}
            HandleDownload={() => HandleDownload()}
            Title={Title}
            className="form-documents mt-0"
            minimized={minimized}
            onMinimizeClick={() => setMinimized(!minimized)}
            showPreferance={toggleModel}
        >
            {/* <h3 className="heading">Documents <span> (In Progress)</span></h3> */}
            {/* {selectedDocument && showModal && ( */}
            <DocumentModal
                selectedDocument={selectedDocument}
                show={showModal}
                handleClose={handleClose}
                document_status={'DRAFTS'}
            />
            {/* )} */}
            <Preferences
                // minimized={isdashPrefMinimized}
                // setMinimized={setIsDashPrefMinimized}
                // togglePreference={togglePreference}
                isActive={showPreferences}
                handleClose={toggleModel}
            />

            {/* <div className="max-h-96 relative new-table-resposive"> */}
            <div className="relative table_box">
                {/* {documents?.data?.data?.length !== 0 &&
                    <BootstrapTable
                        keyField='_id'
                        data={documents?.data?.data}
                        columns={documentsColumns}
                        hover
                        headerClasses="header-class"
                    />
                } */}
                {documents?.data?.data?.length !== 0 &&
                    <>
                        <Table columns={antTableCols} dataSource={documents?.data?.data} onChange={onChange} pagination={false} />
                    </>
                }
            </div>

        </MinimizableContainer>
        // <div className="form-documents">

        // </div>
    )
}

function Title() {
    return <h3 style={{ marginBottom: 0, marginLeft: 12 }} className="heading">Brouillons</h3>
}

export default DocumentsInProgress
